@if (isPageLoading()) {
  <lib-overlay-loader />
} @else {
  <div class="h-full flex flex-col justify-between">
    <div>
      <div class="pb-2xl">
        <h5 class="text-neutral-900 text-xl font-semibold text-2xl mb-md">
          {{
            !editMode()
              ? ('job_titles_form_add_title' | transloco)
              : ('job_titles_form_edit_title' | transloco)
          }}
        </h5>
      </div>
      <div class="py-lg mb-lg border-b border-neutral-200">
        <h5 class="text-neutral-900 text-lg font-semibold text-2xl">
          {{ 'job_titles_form_job_title_info' | transloco }}
        </h5>
      </div>
      <form
        class="flex gap-lg flex-wrap"
        [formGroup]="addJobTitleForm()"
        libScrollToError>
        <div class="input-width">
          <div>
            <div formGroupName="name">
              <dual-lang-input
                [requiredGroup]="true"
                [inputFormControlName]="'name'"
                [id]="'name'"
                type="text"
                name="name"
                [requiredEn]="false"
                [requiredAr]="false"
                [label]="'job_titles_form_job_title_name_label' | transloco"
                [placeholderEn]="
                  'job_titles_form_job_title_name_placeholder_en' | transloco
                "
                [placeholderAr]="
                  'job_titles_form_job_title_name_placeholder_ar' | transloco
                " />
            </div>
            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="name" />
          </div>
        </div>
        <div class="input-width">
          <lib-input
            [inputFormControlName]="'identifier'"
            [id]="'identifier'"
            type="text"
            name="identifier"
            [label]="'job_titles_form_job_title_id_label' | transloco"
            [placeholder]="'id_input_default_placeholder' | transloco" />
          <lib-validation-message
            [lang]="'current_lang' | transloco"
            control="identifier" />
        </div>
        <div class="input-width">
          <lib-paginated-select
            [id]="'track_option_id'"
            [inputFormControlName]="'track_option_id'"
            [name]="'track_option_id'"
            [label]="'job_titles_form_track_label' | transloco"
            [placeholder]="'job_titles_form_track_placeholder' | transloco"
            [apiUrl]="variableOptionsApi"
            [filters]="trackFilter"
            [selectedOption]="selectedTrack"
            [noDataLabel]="'user_dropdown_input_no_data_label' | transloco" />
          <lib-validation-message
            [lang]="'current_lang' | transloco"
            control="track_option_id" />
        </div>
        <div class="input-width">
          <lib-paginated-select
            [id]="'radford_grade_option_id'"
            [inputFormControlName]="'radford_grade_option_id'"
            [name]="'radford_grade_option_id'"
            [label]="'job_titles_form_radford_grade_label' | transloco"
            [placeholder]="
              'job_titles_form_radford_grade_placeholder' | transloco
            "
            [apiUrl]="variableOptionsApi"
            [filters]="radfordGradeFilter"
            [selectedOption]="selectedRadfordGrade"
            [noDataLabel]="'user_dropdown_input_no_data_label' | transloco" />
          <lib-validation-message
            [lang]="'current_lang' | transloco"
            control="radford_grade_option_id" />
        </div>
        <div class="input-width">
          <lib-paginated-select
            [id]="'job_family_option_id'"
            [inputFormControlName]="'job_family_option_id'"
            [name]="'job_family_option_id'"
            [label]="'job_titles_form_job_family_label' | transloco"
            [placeholder]="'job_titles_form_job_family_placeholder' | transloco"
            [apiUrl]="variableOptionsApi"
            [filters]="jobFamilyFilter"
            [selectedOption]="selectedJobFamily"
            [noDataLabel]="'user_dropdown_input_no_data_label' | transloco" />
          <lib-validation-message
            [lang]="'current_lang' | transloco"
            control="job_family_option_id" />
        </div>
      </form>
    </div>
    <div class="flex gap-lg justify-end">
      <a
        id="cancel"
        class="px-2xl py-sm rounded-md text-neutral-700 bg-white text-lg font-medium cursor-pointer"
        [routerLink]="[
          editMode()
            ? (`${ADMIN_ROUTES.JOB_TITLES.DETAILS}/${jobTitleId}`
              | tenantPath: 'admin')
            : (`${ADMIN_ROUTES.JOB_TITLES.LIST}` | tenantPath: 'admin'),
        ]">
        {{ 'department_form_screen_cancel_button' | transloco }}
      </a>

      <button
        [disabled]="isLoading()"
        [class.opacity-30]="isLoading()"
        id="submit"
        (click)="addEditJobTitle()"
        class="px-2xl py-sm rounded-md text-white bg-primary-500 text-lg font-medium border-none cursor-pointer">
        {{
          !editMode()
            ? ('job_titles_form_add_job_title' | transloco)
            : ('job_titles_form_save_edits' | transloco)
        }}
      </button>
    </div>
  </div>
}
